import Rest from '../Rest'

export interface PaymentGatewayOption {
  value: string
  label: string
  configured: boolean
}

export interface PaymentGatewaySettings {
  active_gateway: string
  options: PaymentGatewayOption[]
  /** Preenchidos apenas na resposta do save. */
  plans_synced?: number
  plans_failed?: Record<string, string>
}

/**
 * Gateway de pagamento ativo da plataforma.
 *
 * A troca vale apenas para novas cobranças e novas assinaturas — pagamentos e
 * assinaturas existentes continuam sendo processados pelo gateway em que foram
 * criados. Ao salvar, o backend registra os planos de assinatura no novo
 * provedor; cartões salvos ficam no gateway anterior e deixam de ser oferecidos.
 */
export default class PaymentGatewaySettingsService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/payments/gateway'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  load(): Promise<PaymentGatewaySettings> {
    return this.get('settings')
  }

  save(gateway: string): Promise<PaymentGatewaySettings> {
    return this.put('settings', { gateway })
  }
}
